// @ts-nocheck: converted from JS

import Create from '@/components/Studies/Requests/Create/Create';

export default Create;
